import { createAction, props } from '@ngrx/store';

import { LowestPriceOfPeriod } from '@fcom/dapi/api/models/lowest-price-of-period';
import { GetPricesForPeriod$Params } from '@fcom/dapi/api/fn/instantsearch/get-prices-for-period';
import { GetPricesForPeriodWithFixedDepartureDate$Params } from '@fcom/dapi/api/fn/instantsearch/get-prices-for-period-with-fixed-departure-date';

export const pricesForPeriodRequestSent = createAction(
  '[InstantSearchActions] PricesForPeriodRequestSent',
  props<{ params: GetPricesForPeriod$Params }>()
);

export const pricesForPeriodResponseReceived = createAction(
  '[InstantSearchActions] PricesForPeriodResponseReceived',
  props<{
    params: GetPricesForPeriod$Params;
    response: LowestPriceOfPeriod;
    createdAt: number;
  }>()
);

export const pricesForPeriodRequestFailed = createAction(
  '[InstantSearchActions] PricesForPeriodRequestFailed',
  props<{ params: GetPricesForPeriod$Params }>()
);

export const fixedDepartureRequestSent = createAction(
  '[InstantSearchActions] FixedDepartureRequestSent',
  props<{ params: GetPricesForPeriodWithFixedDepartureDate$Params }>()
);

export const fixedDepartureResponseReceived = createAction(
  '[InstantSearchActions] FixedDepartureResponseReceived',
  props<{
    params: GetPricesForPeriodWithFixedDepartureDate$Params;
    response: LowestPriceOfPeriod;
    createdAt: number;
  }>()
);

export const fixedDepartureRequestFailed = createAction(
  '[InstantSearchActions] FixedDepartureRequestFailed',
  props<{ params: GetPricesForPeriodWithFixedDepartureDate$Params }>()
);
